import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["suggestionChangedHiddenField", "followSuggestionSwitch"];

  followSuggestionSwitchTargetConnected(element) {
    element.addEventListener("change", this.onChange);
  }

  followSuggestionSwitchTargetDisconnected(element) {
    element.removeEventListener("change", this.onChange);
  }

  onChange = (event) => {
    if (event.target.checked) {
      this.suggestionChangedHiddenFieldTarget.value = "true";
      this.suggestionChangedHiddenFieldTarget.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }
  };
}
